export default {
  product: {
    title: 'Товар',
    selfCustodyWallet: 'Мобильный кошелек',
    selfCustodyWalletDesc: 'Мобильный кошелек Crypto&DeFi на блокчейне.',
    hardwareWallet: 'Аппаратный кошелек',
    hardwareWalletDesc: 'Получите свой KeyPal, чтобы защитить свои активы.',
    extensionWallet: 'Расширение кошелька',
    extensionWalletDesc: 'Лучший кошелек на вашем компьютере.',
    transit: 'Transit',
    transitDesc: 'Многоцепочечный агрегатор DEX и торговая площадка NFT.',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Протокол социальной сети в Web3.0.',
    stakeVault: 'ETH Staking Vault',
    stakeVaultDesc:
      'Поддерживает и самостоятельный стейкинг, и стейкинг с небольшими суммами',
  },
  project: {
    subToken: 'Отправить токен',
    subDApp: 'Отправить DApp',
    subNFT: 'Отправить NFT',
    subChain: 'Цепь',
  },
  assets: {
    title: 'Ресурсы',
  },
  collaborations: {
    title: 'Сотрудничество',
  },
  community: {
    title: 'Сообщество',
    developers: 'Разработчик',
    recruiting: 'ТП-мужчина',
  },
  helpCenter: {
    title: 'Помощь',
  },
  features: {
    title: 'Особенности',
    buyCrypto: 'Купить криптовалюту',
    mobileWallet: 'Мобильный кошелек',
    hardwareWallet: 'Аппаратный кошелек',
    extensionWallet: 'Расширение кошелька',
    desktop: 'Настольный кошелек',
    fiveDegrees: '5Degrees',
    versionVerification: 'Version Verification',
    approvalDetector: 'Детектор одобрения',
    tokenSecurity: 'Безопасность токена',
    keyGenerator: 'Генератор ключей',
    BATCH_SENDER: 'Отправитель пакета',
  },
  information: {
    title: 'Информация',
    blockchainGuide: 'Руководство по блокчейну',
    tronWallet: 'Руководство по TRON',
    iostWallet: 'Руководство по IOST',
    tpMan: 'ТП-мужчина',
  },
  developers: {
    title: 'Разработчики',
    github: 'Github (TP-Lab)',
    devCenter: 'Центр разработки',
    subToken: 'Отправить токен',
    subDApp: 'Отправить DApp',
    subNFT: 'Отправить NFT',
  },
  company: {
    title: 'Компания',
    about: 'О',
    careers: 'Карьера',
    pressKit: 'Пресс-кит',
    swagShop: 'Магазин сувениров',
  },
  support: {
    title: 'Поддержка',
    helpCenter: 'Справочный центр',
    contactUs: 'Свяжитесь с нами',
  },
  legal: {
    title: 'Юридический',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms of Use',
  },
  main: {
    title: 'Проверка версии',
    language: 'Русский',
    intro:
      'Проверка версии выполняется путем сопоставления хэш-значений MD5 или SHA256 между версиями. Пожалуйста, убедитесь, что вы загружаете кошелек TokenPocket через официальные каналы, чтобы избежать обмана. Для получения инструкций о том, как получить хэш-значения MD5 или SHA256 для версии, пожалуйста, ',
    tutorial: 'обратитесь к руководству >',
    system: 'ОС',
    android: 'Android',
    ios: 'iOS',
    version: 'Версия',
    allVersion: 'Все',
    appChannel: 'Канал приложения',
    developer: 'разработчик',
    allChannel: 'Все',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Журнал версий',
    check: 'Подробнее',
    versionLog: 'Журнал версий',
    confirm: 'Подтвердить',
    aboutIOS: 'О версии iOS',
    IOSDesc:
      'Для версий iOS мы предлагаем наше приложение только в App Store. Только приложения, загруженные из App Store, могут быть правильно установлены. Поэтому, используя устройства Apple, пожалуйста, убедитесь, что вы аутентифицируете App Store как единственный канал загрузки.',
    IOSDesc_2:
      'Разработчиком версии, загруженной из App Store до 8 октября 2022 года, является TOKENPOCKET FOUNDATION LTD, которая является ранней версией, разработанной TokenPocket. Это легитимный кошелек, который можно использовать нормально, но услуга обновления временно приостановлена.',
    aboutAndroid: 'О версии Android',
    androidDesc: 'В настоящее время TokenPocket предлагает каналы загрузки для Android, включая официальный веб-сайт, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store и Vivo App Store. В некоторых приложениях из магазинов невозможно получить установочный файл APK во время загрузки, поэтому нельзя выполнить проверку на соответствие MD5 или SHA256. Поэтому, при загрузке обязательно проверяйте информацию о разработчике и справочную информацию ниже!',
    IOSAppName: 'Название приложения:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Иконка приложения:',
    AppDeveloper: 'Разработчик:',
    downloadLink: 'Ссылка для загрузки:',
    copied: 'Скопировано!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Подписывайтесь на нас',
    desc1: 'Сотрудники TokenPocket не будут отправлять вам личные сообщения!',
    desc2:
      'Осторожность! Вы входите в сообщество TokenPocket, возможно, кто-то выдает себя за нас, чтобы отправлять вам личные сообщения! Имейте в виду, что любой, кто отправляет личные сообщения, может быть мошенником! Мы никогда не свяжемся с вами первыми!',
    desc3: 'Понятно, вводите',
  },
};
